module.exports = __webpack_public_path__ + "skill_design.c5de90e8.svg";